module.exports = __webpack_public_path__ + "static/media/5.Lapeta pipes.a879bd21.jpg";